import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import Snackbar from 'material-ui/Snackbar';
import Checkbox from 'material-ui/Checkbox';
import Popover from 'material-ui/Popover';
import TextField from 'material-ui/TextField';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import DatePicker from 'material-ui/DatePicker';
import { getReports } from 'redux/modules/reporting';
import { getFBAdPreviewSrc } from 'redux/modules/adBuilder';
import { clearUpcomingContentTemplate, getUpcomingPosts } from 'redux/modules/reportUpcomingContent';
import { clearFBChecklistTemplate, getPageFields, updateFBChecklist } from 'redux/modules/reportFacebookChecklist';
import { clearTemplate, getPageStats, getRecentPosts, getPageInsights, getAds } from 'redux/modules/reportSocialMediaSummary';
import { clearSettings, getWhitelabelInfo, loadReport, simpleGetReport, updateField, updateNonAsyncField, updateSelectedClient } from 'redux/modules/reportBuilder';
import { clearOrgSearchResults, searchUserOrganizations } from 'redux/modules/auth';
import { ListItem } from 'material-ui/List';
import { LeftNavLayout } from 'containers';
import { PageHeader, Spinner } from 'components';
import * as styles from './ReportBuilder.scss';
var Settings = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    fetchingOrganization: state.organization.fetchingOrganization,
    orgSearchResults: state.auth.orgSearchResults && state.auth.orgSearchResults.organizations ? state.auth.orgSearchResults.organizations : [],
    reportBuilderOrgSearch: state.auth.reportBuilderOrgSearch,
    searchingOrganizations: state.auth.searchingOrganizations,
    selectedClient: state.reportBuilder.selectedClient,
    reportTypes: state.reportBuilder.reportTypes,
    startDate: state.reportBuilder.startDate,
    endDate: state.reportBuilder.endDate,
    reportTitle: state.reportBuilder.reportTitle,
    usePartnerBranding: state.reportBuilder.usePartnerBranding
  };
}, {
  clearOrgSearchResults: clearOrgSearchResults,
  clearSettings: clearSettings,
  clearFBChecklistTemplate: clearFBChecklistTemplate,
  clearUpcomingContentTemplate: clearUpcomingContentTemplate,
  clearTemplate: clearTemplate,
  getFBAdPreviewSrc: getFBAdPreviewSrc,
  getPageFields: getPageFields,
  getReports: getReports,
  getUpcomingPosts: getUpcomingPosts,
  getWhitelabelInfo: getWhitelabelInfo,
  loadReport: loadReport,
  simpleGetReport: simpleGetReport,
  searchOrgs: searchUserOrganizations,
  updateField: updateField,
  updateNonAsyncField: updateNonAsyncField,
  getPageStats: getPageStats,
  getRecentPosts: getRecentPosts,
  getPageInsights: getPageInsights,
  getAds: getAds,
  updateSelectedClient: updateSelectedClient,
  updateFBChecklist: updateFBChecklist
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(Settings, _Component);

  var _super = _createSuper(Settings);

  function Settings(props) {
    var _this;

    _classCallCheck(this, Settings);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getMinEndDate", function (startDate) {
      var d = moment().date(2).subtract(1, 'month');

      if (startDate) {
        return moment(startDate).add(1, 'day');
      }

      return d;
    });

    _defineProperty(_assertThisInitialized(_this), "handleSearchTextChange", function (event) {
      var value = event.target.value;

      _this.setState({
        searchText: value,
        popoverAnchor: event.target
      }, function () {
        if (value.length > 1) {
          _this.props.searchOrgs(_this.state.searchText, 1, true);
        }
      });
    });

    _this.state = {
      searchText: props.org ? props.org.name : '',
      snackbarMessage: '',
      snackbarOpen: false
    };
    return _this;
  }

  _createClass(Settings, [{
    key: "UNSAFE_componentWillUpdate",
    value: function UNSAFE_componentWillUpdate(nextProps, nextState) {
      if (nextProps.org && !this.props.org) {
        this.setState({
          searchText: nextProps.org.name
        });
      }

      if (this.props.selectedClient && !nextProps.selectedClient) {
        this.setState({
          searchText: ''
        });
      }
    }
  }, {
    key: "render",
    value:
    /** *******************************************************************************************
     RENDER
    ********************************************************************************************/
    function render() {
      var _this2 = this;

      var minEndDate = this.getMinEndDate(this.props.startDate).toDate();
      return /*#__PURE__*/React.createElement("div", {
        className: styles.settingsBar
      }, /*#__PURE__*/React.createElement(TextField, {
        className: styles.settingsBarItem,
        floatingLabelFixed: true,
        floatingLabelText: "Client",
        hintText: "Search",
        inputStyle: {
          width: 250
        },
        value: this.props.fetchingOrganization ? 'Loading...' : this.props.reportId && this.props.selectedClient ? this.props.selectedClient.name : this.state.searchText,
        onChange: this.handleSearchTextChange,
        disabled: !!this.props.reportId || this.props.fetchingOrganization
      }), /*#__PURE__*/React.createElement(Popover, {
        open: !!this.props.orgSearchResults.length && this.props.reportBuilderOrgSearch,
        anchorEl: this.state.popoverAnchor,
        anchorOrigin: {
          horizontal: 'left',
          vertical: 'bottom'
        },
        targetOrigin: {
          horizontal: 'left',
          vertical: 'top'
        },
        onRequestClose: function onRequestClose() {
          _this2.props.clearOrgSearchResults();

          _this2.setState({
            searchText: ''
          });
        },
        style: {
          padding: 12
        }
      }, /*#__PURE__*/React.createElement(Menu, {
        disableAutoFocus: true,
        maxHeight: 300
      }, this.props.orgSearchResults.map(function (org, index) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          primaryText: org.name,
          id: org.id,
          key: index,
          onClick: function onClick() {
            if (org.SocialAccounts && !!org.SocialAccounts.length) {
              var SocialAccountId = parseInt(org.SocialAccounts[0].id, 10);
              var FacebookAdAccountId = parseInt(org.SocialAccounts[0].id, 10);
              _this2.props.reportType === 'socialMediaSummary' ? _this2.props.clearTemplate() : _this2.props.reportType === 'facebookChecklist' ? _this2.props.clearFBChecklistTemplate() : _this2.props.clearUpcomingContentTemplate();

              _this2.setState({
                searchText: org.name
              });

              _this2.props.updateField('clientName', org.name);

              _this2.props.updateSelectedClient(parseInt(org.id, 10), org.name, FacebookAdAccountId, SocialAccountId).then(function () {
                if (_this2.props.reportType === 'socialMediaSummary') {
                  _this2.props.clearOrgSearchResults();

                  browserHistory.push({
                    pathname: "/global/report-builder/org/".concat(org.id, "/reportType/socialMediaSummary")
                  });
                } else if (_this2.props.reportType === 'upcomingContent') {
                  _this2.props.clearOrgSearchResults();

                  browserHistory.push({
                    pathname: "/global/report-builder/org/".concat(org.id, "/reportType/upcomingContent")
                  });
                } else if (_this2.props.reportType === 'facebookChecklist') {
                  _this2.props.clearOrgSearchResults();

                  browserHistory.push({
                    pathname: "/global/report-builder/org/".concat(org.id, "/reportType/facebookChecklist")
                  });
                }
              });
            } else {
              _this2.setState({
                searchText: ''
              }, function () {
                _this2.props.clearOrgSearchResults();

                setTimeout(function () {
                  alert('This client has no facebook page connected.');
                }, 100);
              });
            }
          }
        });
      }))), this.props.orgId && /*#__PURE__*/React.createElement(SelectField, {
        className: styles.settingsBarItem,
        floatingLabelText: "Report Type",
        floatingLabelFixed: true,
        menuStyle: {
          width: 250
        },
        value: this.props.reportType,
        disabled: !!this.props.reportId
      }, this.props.reportTypes.map(function (type, index) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          key: index,
          value: type.key,
          primaryText: type.name,
          onClick: function onClick() {
            browserHistory.push({
              pathname: "/global/report-builder/org/".concat(_this2.props.orgId, "/reportType/").concat(type.key)
            });
          }
        });
      })), this.props.orgId && (this.props.reportType === 'socialMediaSummary' || this.props.reportType === 'upcomingContent') && /*#__PURE__*/React.createElement(DatePicker, {
        firstDayOfWeek: 0,
        className: styles.settingsBarItem,
        floatingLabelText: "Start Date",
        style: {
          flex: '0 0 130px'
        },
        textFieldStyle: {
          width: 130
        },
        hintText: "Start Date",
        value: moment(this.props.startDate).toDate(),
        onChange: function onChange(e, date) {
          if (moment(date).isAfter(_this2.props.endDate)) {
            _this2.props.updateField('endDate', moment(date).add(1, 'day'));
          }

          _this2.props.updateField('startDate', moment(date)).then(function () {
            _this2.props.getReportStuff(_this2.props.orgId, _this2.props.reportType);
            /*
            browserHistory.push({
              pathname: `/global/report-builder/org/${this.props.orgId}/reportType/${this.props.reportType}`
            });
            */

          });
        },
        minDate: this.props.reportType === 'socialMediaSummary' ? moment().subtract(90, 'days').toDate() : moment().toDate(),
        maxDate: this.props.reportType === 'socialMediaSummary' ? moment().subtract(1, 'day').toDate() : moment().add(6, 'weeks').toDate()
      }), this.props.orgId && (this.props.reportType === 'socialMediaSummary' || this.props.reportType === 'upcomingContent') && /*#__PURE__*/React.createElement(DatePicker, {
        firstDayOfWeek: 0,
        className: styles.settingsBarItem,
        floatingLabelText: "End Date",
        hintText: "End Date",
        style: {
          flex: '0 0 130px'
        },
        textFieldStyle: {
          flex: '0 0 130px',
          width: 130
        },
        value: moment(this.props.endDate).toDate(),
        onChange: function onChange(e, date) {
          _this2.props.updateField('endDate', moment(date)).then(function () {
            _this2.props.getReportStuff(_this2.props.orgId, _this2.props.reportType);
          });
        },
        minDate: minEndDate,
        maxDate: this.props.reportType === 'socialMediaSummary' ? moment().toDate() : moment().add(3, 'months').toDate()
      }), this.props.orgId && /*#__PURE__*/React.createElement(TextField, {
        className: styles.settingsBarItem,
        disabled: this.props.fetchingOrganization,
        floatingLabelFixed: true,
        floatingLabelText: "Report Title",
        hintText: "Report Title",
        inputStyle: {
          width: 250
        },
        style: {
          height: 73
        },
        value: this.props.fetchingOrganization ? 'Loading...' : this.props.reportTitle,
        onChange: function onChange(event) {
          _this2.props.updateNonAsyncField('reportTitle', event.target.value);
        }
      }), /*#__PURE__*/React.createElement(Snackbar, {
        message: this.state.snackbarMessage,
        open: this.state.snackbarOpen,
        autoHideDuration: 4000,
        onRequestClose: function onRequestClose() {
          _this2.setState({
            snackbarOpen: false
          });
        }
      }));
    }
  }]);

  return Settings;
}(Component)) || _class);
export { Settings as default };